"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutosaveSaving = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var AutosaveSaving = function AutosaveSaving() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a6.54 6.54 0 016.45 5.477A5.996 5.996 0 0118 20.454H5.455a5.455 5.455 0 010-10.909A6.546 6.546 0 0112 3zm4.017 9.38l.226-.226a.546.546 0 000-.772l-3.857-3.857a.541.541 0 00-.771 0l-3.856 3.857a.544.544 0 000 .772l.225.226c.102.102.24.16.385.16h1.45v4.096c0 .301.244.546.545.546h3.272a.545.545 0 00.546-.546V12.54h1.449a.545.545 0 00.386-.16z",
    clipRule: "evenodd"
  }));
};

exports.AutosaveSaving = AutosaveSaving;